<template>
   <!-- <div id="asset" :style="style" class="asset-wrapper" v-bind:class="{active: active, hidden_zone: isHidden}"> -->
   <div id="asset" class="asset-wrapper" v-bind:class="{active: active, hidden_zone: isHidden, locked: locked}">
      <div class="zone-label" :style="getZoneLabelStyle">Zone {{zone.id/1000}} {{zone.name}}</div>
      <slot>
      </slot>
   </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
   
   props: {
      currScene: '',
      isHidden: Boolean,
      scale: String,
      zone: {},
   },

   computed: {
      ...mapState([
         'moveImageZoneId',
         'locked'
      ]),

      active() {
         //if an image zone is in "move state" and this zone is not
         //that zone, we're going to hide it
         let movingActive = false;
         if (this.moveImageZoneId == -1 || (this.moveImageZoneId > 0 && this.zone.id == this.moveImageZoneId)) {
            movingActive = true;
         } 

         //if the zone is not in the current scene, hide it
         if (this.zone.scene) {
            let inCurrScene = $.inArray(this.currScene, this.zone.scene) > -1;
            return inCurrScene && movingActive;
         } else {
            this.zone.scene = ["scene1"];
         }

         return movingActive;
      },

      style () {
         if (this.active) {
            let top, left, width, height;
            if (this.zone.animation != null) {
               top = this.zone.animation[this.currScene].end.y;
               left = this.zone.animation[this.currScene].end.x;

               if (this.zone.animation[this.currScene].end.width) {
                  width = this.zone.animation[this.currScene].end.width;
                  height = this.zone.animation[this.currScene].end.height;
               } else {
                  width = this.zone.width;
                  height = this.zone.height;
               }
            } else {
               top = this.zone.y;
               left = this.zone.x;
               width = this.zone.width;
               height = this.zone.height;
            }
            return 'width: ' + width + 'px; height: ' + height + 'px; z-index: ' + (this.zone.layer * 1000) + '; top: ' + top + 'px; left: ' + left + 'px;' + 'border: 1px solid ' + this.getAssetColor();
         }
      },

      getLayer() {
         if (this.zone.animation != null) {
            if (this.zone.animation[this.currScene].end.layer) {
               return 'z-index: ' + this.zone.animation[this.currScene].end.layer * 1000;
            }
            return 'width: ' + this.zone.width + 'px; height: ' + this.zone.height + 'px; z-index: ' + (this.zone.layer * 1000) + '; top: ' + top + 'px; left: ' + left + 'px;' + 'border: 2px solid ' + this.getAssetColor();
         }
         return 'z-index: ' + this.zone.layer * 1000;
      },

      noEditStyle() {
         let top, left;
         if (this.zone.animation != null) {
            top = this.zone.animation[this.currScene].end.y;
            left = this.zone.animation[this.currScene].end.x
         } else {
            top = this.zone.y;
            left = this.zone.x;
         }
         return 'width: ' + this.zone.width + 'px; height: ' + this.zone.height + 'px; z-index: ' + (this.zone.layer * 1000) + '; top: ' + top + 'px; left: ' + left + 'px;';
      },

      getZIndex() {
         return 'z-index: ' + this.zone.layer * 1000;
      },

      getZoneLabelStyle() {
         if (this.active) {
            let top, left;
            if (this.zone.animation != null) {
               top = this.zone.animation[this.currScene].end.y;
               left = this.zone.animation[this.currScene].end.x;
            } else {
               top = this.zone.y;
               left = this.zone.x;
            }
            if (top == undefined) {
               top = 0;
            }
            if (left == undefined) {
               left = 0;
            }
            // if (this.zone.offset_zone_label) {
            //    left = left + 174;
            // }
            if (this.zone.right_align_zone_label) {
               //right aligning the zone label by adding the width of the zone
               //and subtracting the width of the zone label div (50)
               left = left + this.zone.width - 100;
            }
            let fontSize = 6;
            let height = 10;
            if (this.scale && this.scale < 1) {
               //we need to make the label larger if the template is being scaled down
               fontSize = 32;
               height = 48;
            }
            return 'background: ' + this.getAssetColor() + '; top: ' + (top - height) + 'px; left: ' + left + 'px; z-index: ' + 100000 + '; font-size: ' + fontSize + 'px; height: ' + height + 'px;';
         }
      },

      getScenes() {
         let classString = '';
         for (let scene of this.zone.scenes) {
            classString += scene + ' ';
         }
         return classString;
      },

    },

    methods: {
       /**
        * Getting the zone's border color according to asset type
        */
       getAssetColor() {
         //if locked, no border
         if (this.locked) {
            return 'transparent';
         }

         let color = '';
         //if we have a value set, use that type, otherwise figure out what type of asset the zone is expecting
         let t = '';
         if (this.zone.val_type) {
            t = this.zone.val_type;
         } else if (this.zone.type instanceof Array) {
            t = this.zone.type[0];
         } else {
            t = this.zone.type;
         }

         switch(parseInt(t)) {
            case 1:
               color = '#de5353';
               break;
            case 2:
               color = '#8fef97';
               break;
            case 3:
               color = '#efd28f';
               break;
            case 6:
               color = "#ea8fef";
               break;
            case 7:
               color = "#009688";
               break;
            case 8: //Weblink
               color = "#ff9800";
               break;
            default: 
               color = "#007bff";
         }

         return color;
      },
    }
}
</script>

<style lang="scss" scoped>

.asset-wrapper {
   display: none;
   position: relative;

   .zone-label {
      position: absolute;
      text-align: center;
      padding: 0 10px;
      font-size: 30px;
      height: 46px;
      color: black;
      text-transform: uppercase;
      font-weight: none;
      white-space: pre;
   }

   &.active {
      display: block;
   }

   &:hover:not(.locked) {
      cursor: pointer;
   }

   &.hidden_zone{
      visibility: hidden;
   }

   &:not(.locked) {
      .asset-shadow {
         &:hover,
         &:focus,
         &:active {
            box-shadow: 0px 0px 10px #1c95db;
         }
      }
   }
}

</style>
